import TablaConciliacion from "../../../TablaConciliacion";

function TablaCovioriente() {
  return <TablaConciliacion nombreUseCase="COVIORIENTE" titulo="COVIORIENTE" />;
}

export default TablaCovioriente;
